// extracted by mini-css-extract-plugin
export default {"container":"BasicFormLabel_container__EDbI4","required":"BasicFormLabel_required__BRRzu","label":"BasicFormLabel_label__ZI3Ll"};